module.exports = __webpack_public_path__ + "img/spillemyndigheden.25a11b13.png";